import React from "react";

import Header from "../components/header";
import Hero from "../components/hero";
import Footer from "../components/footer";
import Billboard from "../components/billboard";
import Metodologia from "../components/metodologia";
import Trajetoria from "../components/trajetoria";
import Benefits from "../components/benefits";
import Programas from "../components/programas";
import Newsletter from "../components/newsletter";

function Home() {
    return (
        <React.Fragment>
            <Header />
            <Hero />
            <Billboard/>
            <Metodologia />
            <Trajetoria />
            <Benefits />
            <Programas />
            <Newsletter />
            <Footer/>
        </React.Fragment>
    )
}

export default Home;